/**
 * @generated SignedSource<<5a4b4c7a6bb1e12b8dd92b2e54782737>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignMultiplePersonsToMultipleSkillsInput = {
  skillIds?: ReadonlyArray<string | null> | null;
  personIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type assignMultiplePersonsToMultipleSkillsMutation$variables = {
  input: AssignMultiplePersonsToMultipleSkillsInput;
};
export type assignMultiplePersonsToMultipleSkillsMutation$data = {
  readonly assignMultiplePersonsToMultipleSkills: {
    readonly skills: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
      readonly persons: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly fullName: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};
export type assignMultiplePersonsToMultipleSkillsMutation = {
  variables: assignMultiplePersonsToMultipleSkillsMutation$variables;
  response: assignMultiplePersonsToMultipleSkillsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignMultiplePersonsToMultipleSkillsPayload",
    "kind": "LinkedField",
    "name": "assignMultiplePersonsToMultipleSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Skill",
        "kind": "LinkedField",
        "name": "skills",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonTypeConnection",
            "kind": "LinkedField",
            "name": "persons",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assignMultiplePersonsToMultipleSkillsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignMultiplePersonsToMultipleSkillsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a0f380c510ba8c26b32080d4da95753a",
    "id": null,
    "metadata": {},
    "name": "assignMultiplePersonsToMultipleSkillsMutation",
    "operationKind": "mutation",
    "text": "mutation assignMultiplePersonsToMultipleSkillsMutation(\n  $input: AssignMultiplePersonsToMultipleSkillsInput!\n) {\n  assignMultiplePersonsToMultipleSkills(input: $input) {\n    skills {\n      id\n      name\n      persons {\n        edges {\n          node {\n            id\n            fullName\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b500904b0e339f3b9563bded285838cf";

export default node;
